import { Button, Flex } from "antd";
import CustomModal from "../../../../components/CustomModal";
import CorrectIocn from "../_icons/CorrectIocn";

type Props = {
  open: boolean;
  onCancel: () => void;
  title: string;
  subTitle: string;
  handleConfirm: () => void;
  loading: boolean;
};

export default function ConfirmModal({
  open,
  title,
  subTitle,
  loading,
  onCancel,
  handleConfirm,
}: Props) {
  return (
    <CustomModal
      width={600}
      title=""
      open={open}
      handleClose={onCancel}
      footer={null}
      closable={false}
    >
      <div className="mb-5">
        <div className="flex flex-col items-center justify-center text-center gap-2">
          <CorrectIocn />

          <div className="text-center justify-start text-slate-700 text-xl font-bold">
            {title}
          </div>

          <div className="text-center justify-start text-slate-700 text-base font-normal">
            {subTitle}
          </div>
        </div>

        <Flex justify="center" align="center" gap={16} className="mt-8">
          <Button
            type="default"
            size="middle"
            className="btn-bordered-primary border
               border-zinc-200 hover:!border-zinc-200 focus:!border-zinc-200 active:!border-zinc-200 w-full"
            onClick={() => onCancel()}
            disabled={loading}
          >
            Cancel
          </Button>

          <Button
            type="primary"
            size="middle"
            onClick={() => handleConfirm()}
            className="w-full"
            disabled={loading}
          >
            Confirm
          </Button>
        </Flex>
      </div>
    </CustomModal>
  );
}
